// The fixed CPM is what we book as the buy price on VAST serving and on the
// standard RTB lane (any non-transit RTB provider), and what fixed-CPM pricing
// charges. Only transit providers on profit-share / revshare never read it, so
// that is the one case the provider form hides it. Pop bids pay the auction
// price, but a pop provider's non-pop requests still go through standard RTB.
export const usesFixedCpm = (form) =>
  form.types.includes("vast") ||
  (form.types.includes("rtb") && !form.allowTransit) ||
  form.pricingModel === "fixed_cpm";
